<section class="details-page__date-range">
    <h3 
      class="ci-heading-h3-s-bold date-range__title"
    >
    {{ 'Fecha' | translate }}
    </h3>
    <p 
      class="ci-paragraph-p3-regular date-range__text">
      {{ start() | date: 'dd-MM-yyyy' }} / {{ end() | date: 'dd-MM-yyyy' }}
    </p>
</section>